/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "返回顶部",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "text",
                name: "文本样式",
                type: "text"
            },
            {
                key: "icon_url",
                name: "图片样式",
                type: "choose-photo"
            },
            {
                key: "width",
                name: "图片宽",
                type: "text"
            },
            {
                key: "right",
                name: "右",
                type: "text"
            },
            {
                key: "bottom",
                name: "下",
                type: "text"
            }
        ]
    }
];

export default config;